import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { StatisticState } from './types';

import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: StatisticState = {
  pushStatisticDetail: [],
  pushStatisticGroup: [],
  pushGroupings: {
    pushGroup: [
      'hour',
      'day',
      'week',
      'month',
    ],
    pushGroupOptionally: [
      'broker_account_login',
      'os',
      'application',
      'message_type',
      'bulk_id',
      'template_id',
    ]
  },
  pushSubscribers: undefined,
  pushHistories: undefined,
};

export const pushStatistic: Module<StatisticState, RootState> = {
  state,
  getters,
  actions,
  mutations
};